import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useResponsiveLayout } from "@/hooks/useResponsiveLayout";

interface AdaptiveContainerProps {
  children: ReactNode;
  className?: string;
  variant?: "default" | "narrow" | "wide" | "full";
  spacing?: "tight" | "normal" | "relaxed";
}

export const AdaptiveContainer = ({
  children,
  className,
  variant = "default",
  spacing = "normal"
}: AdaptiveContainerProps) => {
  const { containerPadding, screenSize } = useResponsiveLayout();

  const getMaxWidth = () => {
    switch (variant) {
      case "narrow":
        return "max-w-2xl";
      case "wide":
        return "max-w-7xl";
      case "full":
        return "max-w-full";
      default:
        return "max-w-6xl";
    }
  };

  const getSpacing = () => {
    const baseSpacing = spacing === "tight" ? "py-4" : spacing === "relaxed" ? "py-8" : "py-6";
    
    if (screenSize === 'mobile') {
      return spacing === "tight" ? "py-2" : spacing === "relaxed" ? "py-6" : "py-4";
    }
    
    return baseSpacing;
  };

  return (
    <div className={cn(
      "mx-auto w-full",
      getMaxWidth(),
      containerPadding,
      getSpacing(),
      className
    )}>
      {children}
    </div>
  );
};